import type { EditorAPI } from '#packages/editorAPI';
import * as stateManagement from '#packages/stateManagement';
import constants from '#packages/constants';
import { publishUtil } from '#packages/util';
import type { publishClickParams } from '@wix/bi-logger-editor/v2/types';

export const getPublishClickBiEventPayload = (
  editorAPI: EditorAPI,
): Pick<
  publishClickParams,
  | 'viewModeSource'
  | 'is_first_manual_publish'
  | 'isPremium'
  | 'numberOfManualPublish'
  | 'devMode'
> => {
  const isMobileEditor = editorAPI.isMobileEditor();
  const isInPreviewMode = editorAPI.preview.isInPreviewMode();
  const viewModeSource = publishUtil.getPublishViewMode(
    isMobileEditor,
    isInPreviewMode,
  );

  const isSitePublished = editorAPI.dsRead?.generalInfo.isSitePublished();
  const siteWasOnlyAutoPublished =
    stateManagement.userPreferences.selectors.getSiteUserPreferences(
      constants.USER_PREFS.PUBLISH.SITE_WAS_ONLY_AUTO_PUBLISHED,
    )(editorAPI.store.getState());
  const isFirstManualPublish = siteWasOnlyAutoPublished || !isSitePublished;

  const isPremium = editorAPI.site.isPremium();

  const numberOfManualPublish =
    stateManagement.userPreferences.selectors.getSiteUserPreferences(
      'numberOfManualPublish',
    )(editorAPI.store.getState()) as number;

  const devMode = editorAPI.developerMode.isEnabled() ? 'on' : 'off';

  return {
    viewModeSource,
    is_first_manual_publish: isFirstManualPublish,
    isPremium,
    numberOfManualPublish,
    devMode,
  };
};
